import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { Watermark } from './Watermark';
const GOLD = '#C9A96E';
export function Hero() {
  return <section className="relative min-h-[80vh] sm:min-h-[88vh] flex items-center justify-center bg-nude-light overflow-hidden px-5 sm:px-6 py-16 sm:py-20 lg:py-24" data-id="element-153" data-mp="9kjwmolen43o">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-154" data-mp="12a0mpfljy8wq">
        <div className="absolute top-[-10%] left-[-5%] w-96 h-96 bg-rosado-soft rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-155" data-mp="x9uqdm4c7y8b"></div>
        <div className="absolute bottom-[-10%] right-[-5%] w-96 h-96 bg-nude rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-156" data-mp="s9qanyb977j5"></div>
      </div>

      {/* Subtle brand watermark behind the headline */}
      <Watermark position="center" size={900} opacity={0.06} data-id="element-157" data-mp="3czfkty10i55i" />

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-158" data-mp="381e0l9runzsg">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-159" data-mp="3j8sfs1yzrlqd">
          <h2 className="text-sm md:text-base font-sans tracking-[0.3em] uppercase mb-5" style={{
          color: GOLD
        }} data-id="element-160" data-mp="399tdd14tkmbt">
            ALEXA BEAUTY{' '}
            <span className="font-light tracking-[0.2em]" data-id="element-161" data-mp="30gq3t3xaotmg">
              Brows And Lashes
            </span>
          </h2>

          <h1 className="text-[2.5rem] md:text-6xl lg:text-7xl font-serif font-medium text-luxury-black leading-tight mb-4" data-id="element-162" data-mp="35akifsy1mieo">
            TODO LO QUE NECESITAS PARA PESTAÑAS, EN UN SOLO KIT.
          </h1>

          {/* Decorative gold line */}
          <motion.div initial={{
          scaleX: 0
        }} animate={{
          scaleX: 1
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="mx-auto mb-8 h-[1px] w-24 origin-center" style={{
          backgroundColor: GOLD
        }} data-id="element-163" data-mp="2hk8685vrlzia" />

          <p className="text-lg md:text-xl text-gray-600 font-sans font-light max-w-2xl mx-auto mb-9 sm:mb-12 leading-relaxed" data-id="element-164" data-mp="ibgjana5x7gj">
            <span style={{
            color: GOLD
          }} className="font-normal" data-id="element-165" data-mp="deq4e3a3ghwp">
              Organiza
            </span>{' '}
            tu trabajo,{' '}
            <span style={{
            color: GOLD
          }} className="font-normal" data-id="element-166" data-mp="15zq1lf863d2x">
              ahorra tiempo
            </span>{' '}
            y proyecta una{' '}
            <span style={{
            color: GOLD
          }} className="font-normal" data-id="element-167" data-mp="3lsypkqaae6eu">
              imagen profesional
            </span>{' '}
            con un kit diseñado para tener todo bajo control, sin
            complicaciones.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-8 text-sm text-gray-500 font-sans mb-8 sm:mb-10" data-id="element-168" data-mp="21amv97jfjola">
            <motion.span whileHover={{
            scale: 1.05
          }} className="flex items-center gap-2 cursor-default transition-colors duration-300" data-id="element-169" data-mp="2697ogn09l808">
              <SparklesIcon className="w-4 h-4 transition-all duration-300" style={{
              color: GOLD
            }} data-id="element-170" data-mp="2fzj2519r2vkb" />
              Elegancia en cada detalle
            </motion.span>
            <motion.span whileHover={{
            scale: 1.05
          }} className="flex items-center gap-2 cursor-default transition-colors duration-300" data-id="element-171" data-mp="2tzbsgvhd79rr">
              <SparklesIcon className="w-4 h-4 transition-all duration-300" style={{
              color: GOLD
            }} data-id="element-172" data-mp="zkr86jwyhg8w" />
              Organización sin esfuerzo
            </motion.span>
            <motion.span whileHover={{
            scale: 1.05
          }} className="flex items-center gap-2 cursor-default transition-colors duration-300" data-id="element-173" data-mp="3vhf9ttxq1dcw">
              <SparklesIcon className="w-4 h-4 transition-all duration-300" style={{
              color: GOLD
            }} data-id="element-174" data-mp="98mi3pan4tu3" />
              Diseñado para resultados profesionales
            </motion.span>
          </div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 0.8
        }} className="text-base md:text-lg text-luxury-dark/80 font-serif italic max-w-xl mx-auto leading-relaxed" data-id="element-175" data-mp="3rhn4dq3mjnbr">
            Trabaja con más seguridad, más orden y más{' '}
            <span style={{
            color: GOLD
          }} className="not-italic font-medium" data-id="element-176" data-mp="1e9dorh1luxvd">
              confianza
            </span>
            … todo empieza con tener lo correcto contigo.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}